import SearchFormNotPopup from './SearchFormNotPopup'
import SearchFormOperatorPopup from './SearchFormOperatorPopup'
import SearchFormInput from './SearchFormInput'

export default function SearchFormRow(props) {
  const { index, detail, handleChange, operatorId, defaultValues } = props
  console.log('SearchFormRow rendered: ', detail.field.name, props)
  
  return (
    <tr className="search-form-table-row">
      <td className="search-form-table-label">{detail.field.name}</td>
      <td className="search-form-table-not-operator"><SearchFormNotPopup index={index} initialOperatorId={operatorId} onChangeFunction={handleChange} defaultValue={defaultValues.notOperator} /></td>
      <td className="search-form-table-operator"><SearchFormOperatorPopup index={index} operators={detail.fieldTypeOperators} onChangeFunction={handleChange} defaultValue={defaultValues.operator} /></td>
      <td className="search-form-table-input"><SearchFormInput index={index} field={detail.field} onChangeFunction={handleChange} defaultValue={defaultValues.inputValue} /></td>
    </tr>
  )
}